import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
export function CallToAction() {
  return <section className="py-16 bg-gradient-to-r from-blue-600 to-indigo-700 text-white" id="buy-now" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="text-center mb-12" data-id="element-46">
          <h2 className="text-3xl font-extrabold sm:text-4xl" data-id="element-47">
            Ready to Reset Your Mind and Regain Your Vitality?
          </h2>
          <p className="mt-4 text-xl text-blue-100 max-w-3xl mx-auto" data-id="element-48">
            Unlock the secrets to mental clarity and boundless energy today.
          </p>
        </div>
        <div className="bg-white rounded-lg shadow-xl overflow-hidden max-w-2xl mx-auto" data-id="element-49">
          <div className="px-6 py-8 sm:p-10 bg-white text-gray-900" data-id="element-50">
            <div className="flex justify-between items-center" data-id="element-51">
              <h3 className="text-2xl font-semibold text-gray-900" data-id="element-52">
                Young Mind: The Ultimate Guide
              </h3>
              <div className="bg-blue-100 rounded-full px-3 py-1 text-sm font-medium text-blue-800" data-id="element-53">
                Digital Ebook
              </div>
            </div>
            <div className="mt-4 flex items-baseline text-6xl font-extrabold" data-id="element-54">
              $9.99
              <span className="ml-1 text-2xl font-medium text-gray-500" data-id="element-55">
                /one-time
              </span>
            </div>
            <p className="mt-5 text-lg text-gray-500" data-id="element-56">
              Transform your mindset and reclaim your vitality with this
              comprehensive guide.
            </p>
            <div className="mt-6" data-id="element-57">
              <ul className="space-y-4" data-id="element-58">
                <li className="flex items-start" data-id="element-59">
                  <div className="flex-shrink-0" data-id="element-60">
                    <CheckIcon className="h-6 w-6 text-green-500" data-id="element-61" />
                  </div>
                  <p className="ml-3 text-base text-gray-700" data-id="element-62">
                    <span className="font-medium text-gray-900" data-id="element-63">21 pages</span>{' '}
                    of concentrated wisdom and actionable strategies
                  </p>
                </li>
                <li className="flex items-start" data-id="element-64">
                  <div className="flex-shrink-0" data-id="element-65">
                    <CheckIcon className="h-6 w-6 text-green-500" data-id="element-66" />
                  </div>
                  <p className="ml-3 text-base text-gray-700" data-id="element-67">
                    <span className="font-medium text-gray-900" data-id="element-68">
                      Instant delivery
                    </span>{' '}
                    via email after purchase
                  </p>
                </li>
                <li className="flex items-start" data-id="element-69">
                  <div className="flex-shrink-0" data-id="element-70">
                    <CheckIcon className="h-6 w-6 text-green-500" data-id="element-71" />
                  </div>
                  <p className="ml-3 text-base text-gray-700" data-id="element-72">
                    <span className="font-medium text-gray-900" data-id="element-73">
                      30-day money-back guarantee
                    </span>{' '}
                    if you're not satisfied
                  </p>
                </li>
                <li className="flex items-start" data-id="element-74">
                  <div className="flex-shrink-0" data-id="element-75">
                    <CheckIcon className="h-6 w-6 text-green-500" data-id="element-76" />
                  </div>
                  <p className="ml-3 text-base text-gray-700" data-id="element-77">
                    <span className="font-medium text-gray-900" data-id="element-78">
                      PDF format
                    </span>{' '}
                    compatible with all devices
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="px-6 py-8 bg-gray-50 text-center" data-id="element-79">
            <a href="https://hustle1988.gumroad.com/l/qtpgyi" className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 w-full justify-center" data-id="element-80">
              Get Your Copy Now
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-81" />
            </a>
            <p className="mt-4 text-sm text-gray-600" data-id="element-82">
              Secure payment processing. Instant digital delivery.
            </p>
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-83">
          <div className="inline-flex items-center justify-center" data-id="element-84">
            <svg className="h-5 w-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-85">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-86" />
            </svg>
            <svg className="h-5 w-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-87">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-88" />
            </svg>
            <svg className="h-5 w-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-89">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-90" />
            </svg>
            <svg className="h-5 w-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-91">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-92" />
            </svg>
            <svg className="h-5 w-5 text-yellow-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-93">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-94" />
            </svg>
            <span className="ml-2 text-blue-100" data-id="element-95">
              Rated 4.9/5 from over 500+ satisfied readers
            </span>
          </div>
        </div>
      </div>
    </section>;
}